/* eslint camelcase: 0 */
import { takeEvery, call, select, take, put } from 'redux-saga/effects';
import intersection from 'lodash.intersection';
import get from 'lodash.get';
import queryString from 'query-string';
import { LOCATION_CHANGE } from 'react-router-redux';
import actionKey from '../utils/action-key';
import request from '../api-utils/request';
import {
    TOGGLE_FILTER,
    TOGGLE_FILTER_STATE,
    RESET_FILTERS,
    FILTER_PROGRAMS,
    resetFiltersAction,
    toggleFilterAction,
} from './filter';
import onetIDToSubjectArea from '../utils/occupationToSubjectArea';
import subjectAreas from '../utils/subjectAreas';
import { FETCH_COLLEGE_PROGRAMS } from './college-programs';

export const FETCH_PROGRAM_MATCHES = 'program/FETCH_PROGRAM_MATCHES';
export const CHANGE_GRADUATION_RATE = 'program/CHANGE_GRADUATION_RATE';
export const CHANGE_TUITION_COAST = 'program/CHANGE_TUITION_COAST';
export const FETCH_PROGRAM_MATCH = 'program/FETCH_PROGRAM_MATCH';
export const GET_CAREER_MATCH = 'program/GET_CAREER_MATCH';
export const FETCH_PROGRAM_DETAILS = 'program/FETCH_PROGRAM_DETAILS';
export const FILTER_MATCHES = 'program/FILTER_MATCHES';
export const SEARCH_MATCHES_MAJOR = 'program/SEARCH_MATCHES_MAJOR';
export const FETCH_OCCUPATION_INDUSTRY = 'program/FETCH_OCCUPATION_INDUSTRY';
export const SEARCH_MATCHES = 'program/SEARCH_MATCHES';
export const SEARCH_MATCHES_LOCATION = 'program/SEARCH_MATCHES_LOCATION';
export const SEARCH_MATCHES_NAME = 'program/SEARCH_MATCHES_NAME';
export const CHANGE_VIEW = 'program/CHANGE_VIEW';

export default (state = {
    careerDetails: null,
    careerMatches: [],
    careerMatch: null,
    currentUserId: null,
    error: false,
    filteredMatches: [],
    loading: false,
    loadingDetails: false,
    occupationToIndustry: {},
    careersByProgram: [],
    occupationToIndustryLoaded: false,
    values: [0, 100],
    tuitionCoast: 0,
    occupationToIndustryLoading: false,
    searchString: '',
    matchesMajorString: '',
    searchLocationString: '',
    searchNameString: '',
    view: 'subject-areas',
}, action) => {
    switch (action.type) {
        case FETCH_PROGRAM_MATCHES: {
            return {
                ...state,
                loading: true,
                currentUserId: action.userId,
            };
        }
        case actionKey.success(FETCH_PROGRAM_MATCHES): {
            return {
                ...state,
                careerMatches: action.payload.programs,
                loading: false,
            };
        }
        case actionKey.success(FETCH_PROGRAM_MATCH): {
            return {
                ...state,
                careerMatch: mergeSubjectArea(action.payload.programs),
            };
        }
        case GET_CAREER_MATCH: {
            return {
                ...state,
                careerMatch: state.careerMatches
                    .find(c => c.occupationID.toString() === action.occupationId),
            };
        }
        case FETCH_PROGRAM_DETAILS: {
            return {
                ...state,
                error: false,
                loadingDetails: true,
            };
        }
        case actionKey.success(FETCH_PROGRAM_DETAILS): {
            return {
                ...state,
                careerDetails: action.payload.program,
                careersByProgram: action.payload.careers,
                error: false,
                loadingDetails: false,
            };
        }
        case actionKey.failure(FETCH_PROGRAM_DETAILS): {
            return {
                ...state,
                careerDetails: null,
                careersByProgram: null,
                error: true,
                loadingDetails: false,
            };
        }
        case FILTER_MATCHES: {
            const result = filterMatches(state.careerMatches, action.filters);
            return {
                ...state,
                filteredMatches: result,
            };
        }
        case SEARCH_MATCHES: {
            return {
                ...state,
                searchString: action.searchString,
            };
        }
        case SEARCH_MATCHES_LOCATION: {
            return {
                ...state,
                searchLocationString: action.searchLocationString,
            };
        }
        case SEARCH_MATCHES_MAJOR: {
            return {
                ...state,
                matchesMajorString: action.matchesMajorString,
            };
        }
        case SEARCH_MATCHES_NAME: {
            return {
                ...state,
                searchNameString: action.searchNameString,
            };
        }
        case CHANGE_GRADUATION_RATE: {
            return {
                ...state,
                values: action.values,
            };
        }
        case CHANGE_TUITION_COAST: {
            return {
                ...state,
                tuitionCoast: action.value,
            };
        }
        case FETCH_OCCUPATION_INDUSTRY: {
            return {
                ...state,
                occupationToIndustryLoading: true,
            };
        }
        case actionKey.success(FETCH_OCCUPATION_INDUSTRY): {
            return {
                ...state,
                occupationToIndustryLoading: false,
                occupationToIndustryLoaded: true,
                occupationToIndustry: action.payload.reduce((acc, current) => {
                    acc[current.occupationID] = acc[current.occupationID]
                        ? acc[current.occupationID] =
                          acc[current.occupationID].concat(current.industryID)
                        : acc[current.occupationID] = [current.industryID];
                    return acc;
                }, {}),
            };
        }
        case actionKey.failure(FETCH_OCCUPATION_INDUSTRY): {
            return {
                ...state,
                occupationToIndustryLoading: false,
                occupationToIndustry: {},
            };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                searchString: '',
                searchLocationString: '',
                matchesMajorString: '',
                values: [0, 100],
                searchNameString: '',
                tuitionCoast: 0,
            };
        }
        case CHANGE_VIEW:
            return {
                ...state,
                view: action.payload,
                searchString: '',
                matchesMajorString: '',
                searchLocationString: '',
                values: [0, 100],
                searchNameString: '',
                tuitionCoast: 0,
            };
        case LOCATION_CHANGE: {
            if (state.view !== 'subject-areas' &&
                action.payload.pathname.indexOf('/career-matches') === -1 &&
                action.payload.pathname.indexOf('/career-details') === -1
            ) {
                return {
                    ...state,
                    view: 'subject-areas',
                };
            }
            return state;
        }
        default:
            return state;
    }
};

/**
 * REDUX ACTIONS
 */

export const fetchProgramMatchesAction = userId => ({
    type: FETCH_PROGRAM_MATCHES,
    userId,
});

export const changeViewAction = payload => ({
    type: CHANGE_VIEW,
    payload,
});

export const fetchCareerMatchAction = (userId, occupationId) => ({
    type: FETCH_PROGRAM_MATCH,
    occupationId,
    userId,
});

export const getCareerMatchAction = occupationId => ({
    type: GET_CAREER_MATCH,
    occupationId,
});

export const fetchProgramDetailsAction = collegeProgramId => ({
    type: FETCH_PROGRAM_DETAILS,
    collegeProgramId,
});

export const fetchOccupationToIndustryAction = () => ({
    type: FETCH_OCCUPATION_INDUSTRY,
});

export const searchMatchesAction = searchString => ({
    type: SEARCH_MATCHES,
    searchString,
});

export const searchMatchesLocationAction = searchLocationString => ({
    type: SEARCH_MATCHES_LOCATION,
    searchLocationString,
});

export const searchMatchesMajorAction = matchesMajorString => ({
    type: SEARCH_MATCHES_MAJOR,
    matchesMajorString,
});

export const searchMatchesNameAction = searchNameString => ({
    type: SEARCH_MATCHES_NAME,
    searchNameString,
});

export const graduationRangeChangeAction = values => ({
    type: CHANGE_GRADUATION_RATE,
    values,
});

export const tuitionCoastChangeAction = value => ({
    type: CHANGE_TUITION_COAST,
    value,
});

/**
 * SAGA LISTENERS
 */

function* lisenFetchCareerMatches() {
    yield takeEvery(FETCH_PROGRAM_MATCHES, fetchCareerMatches);
}

function* lisenFetchCareerMatch() {
    yield takeEvery(FETCH_PROGRAM_MATCH, fetchCareerMatch);
}

function* listenFetchProgramDetails() {
    yield takeEvery(FETCH_PROGRAM_DETAILS, fetchProgramDetails);
}

function* listenFilterEvents() {
    yield takeEvery([
        actionKey.success(FETCH_PROGRAM_MATCHES),
        actionKey.success(FETCH_COLLEGE_PROGRAMS),
        RESET_FILTERS,
        CHANGE_VIEW,
        SEARCH_MATCHES,
        SEARCH_MATCHES_LOCATION,
        SEARCH_MATCHES_MAJOR,
        SEARCH_MATCHES_NAME,
        CHANGE_GRADUATION_RATE,
        CHANGE_TUITION_COAST,
        TOGGLE_FILTER,
        TOGGLE_FILTER_STATE,
    ], filterEvent);
}

function* listenFetchOccupationToIndustry() {
    yield takeEvery(FETCH_OCCUPATION_INDUSTRY, fetchOccupationToIndustry);
}

export function* rootSaga() {
    yield [
        lisenFetchCareerMatches(),
        lisenFetchCareerMatch(),
        listenFetchProgramDetails(),
        listenFilterEvents(),
        listenFetchOccupationToIndustry(),
        takeEvery(LOCATION_CHANGE, filterOnCollegeProgramRoute),
    ];
}

/**
 * REDUX SAGAS
 */

function* fetchCareerMatches({ userId, type }) {
    yield call(request, {
        url: `/api/administration/custom-programs/programs-all?userId=${userId}`,
        type,
        options: {
            method: 'GET',
        },
    });
}

function* fetchCareerMatch({ userId, occupationId, type }) {
    yield call(request, {
        url: `/api/career/match?userId=${userId}&occupationId=${occupationId}`,
        type,
        options: {
            method: 'GET',
        },
    });
}

function* fetchProgramDetails({ collegeProgramId, type }) {
    const customProgramsID_PK = collegeProgramId;
    yield call(request, {
        url: `/api/administration/custom-programs/programs/${customProgramsID_PK}`,
        type,
        options: {
            method: 'GET',
        },
    });
}

function* fetchOccupationToIndustry({ type }) {
    const { career: { occupationToIndustryLoaded } } = yield select();

    if (!occupationToIndustryLoaded) {
        yield call(request, {
            url: '/api/industries/occupations',
            type,
            options: {
                method: 'GET',
            },
        });
    }
}

function* filterEvent() {
    const {
        filterPrograms,
        programs: { searchString, searchLocationString,
            values, tuitionCoast, matchesMajorString, searchNameString },
        favoritePrograms: favorites,
        favoriteProgramsCareer: favoritesCareer,
        collegePrograms,
    } = yield select();

    const filters = {
        format: filterPrograms.format,
        schoolType: filterPrograms.schoolType,
        schoolSize: filterPrograms.schoolSize,
        degreeType: filterPrograms.degreeType,
        searchString,
        values,
        tuitionCoast,
        matchesMajorString,
        searchNameString,
        searchLocationString,
        favorite: filterPrograms.favorite,
        favorites,
        favoritesCareer,
        programs: Object.keys(filterPrograms.programs).reduce((acc, id) => {
            const collegeProgram = get(collegePrograms, 'list', []).find(p => (
                Number(p.id) === Number(id)
            ));
            if (!collegeProgram) {
                return acc;
            }
            collegeProgram.occupations.forEach((occ) => {
                acc[occ] = true;
            });
            return acc;
        }, {}),
    };

    yield put({ type: FILTER_MATCHES, filters });
}

function* filterOnCollegeProgramRoute({ payload: { search } }) {
    const query = queryString.parse(search);
    if (!query.program) {
        return;
    }
    const id = query.program;
    let state = yield select();
    if (id) {
        yield put(changeViewAction('careers'));
    }
    let program = get(state, 'collegePrograms.list', []).find(p => Number(p.id) === Number(id));
    if (!program) {
        yield take(actionKey.success(FETCH_COLLEGE_PROGRAMS));
        state = yield select();
        program = get(state, 'collegePrograms.list', []).find(p => Number(p.id) === Number(id));
        if (!program) {
            return;
        }
    }
    yield put(resetFiltersAction());
    yield put(toggleFilterAction({
        filterId: FILTER_PROGRAMS,
        filterOptionId: program.id.toString(),
        label: program.name,
        selected: false,
    }));
}

/**
 * PRIVATE FUNCTIONS
 */

const mergeSubjectArea = (careerMatch) => {
    const subjectAreaID = onetIDToSubjectArea[careerMatch.onetID];
    return {
        ...careerMatch,
        subjectAreaID,
        subjectAreaName: subjectAreas[subjectAreaID],
    };
};

const filterMatches = (
    careerMatches,
    { format, matchesMajorString,
        values, tuitionCoast, searchString, searchLocationString, searchNameString,
        favorite, favorites, degreeType, schoolType, schoolSize, favoritesCareer },
) => (
    careerMatches
        .filter(m => filterContainsField(degreeType, m.degreeType))
        .filter(m => filterContainsField(format, m.format))
        .filter(m => filterContainsField(schoolSize, m.schoolSize))
        .filter(m => filterContainsField(schoolType, m.schoolType))
        .filter(m => search(searchString, m))
        .filter(m => filterByRange(values, m.graduationRate))
        .filter(m => filterByTuition(tuitionCoast, m.tuitionCost))
        .filter(m => searchName(searchNameString, m))
        .filter(m => searchByMajor(matchesMajorString, m))
        .filter(m => searchLocation(searchLocationString, m))
        .filter(m => (favorite && favorite.selected ? favorites[m.programId] : true))
        .filter(m => (favorite && favorite.selectedCareers ? favoritesCareer[m.programId] : true))
);

const filterContainsField = (filter, field) => {
    if (typeof filter === 'undefined' || Object.keys(filter).length < 1) return true; // Filter empty, so ignore this filter.
    if (field === null || typeof field === 'undefined') {
        return false; // Incomplete data, so skip this match.
    }

    const selectedFilterOptions = Object.keys(filter).reduce((acc, filterKey) => {
        if (filter[filterKey].selected) acc.push(filterKey);
        return acc;
    }, []);

    // Nothing selected, so ignore this filter.
    if (selectedFilterOptions.length < 1) return true;

    if (Array.isArray(field)) {
        return intersection(selectedFilterOptions,
            field.map(f => f.toString())).length > 0;
    }

    return selectedFilterOptions.indexOf(field.toString()) !== -1;
};

const search = (searchString, { name, detail }) => {
    if (!searchString) return true;
    const query = searchString.toLowerCase();
    const title = name ? name.toLowerCase() : '';
    const desc = detail ? detail.toLowerCase() : '';

    return title.includes(query) || desc.includes(query);
};

const searchLocation = (searchLocationString, { locations }) => {
    if (!searchLocationString) return true;
    const location = JSON.stringify(locations);
    const query = searchLocationString.toLowerCase();
    const title = location ? location.toLowerCase() : '';

    return title.includes(query);
};

const searchName = (searchNameString, { schoolName }) => {
    if (!searchNameString) return true;
    const query = searchNameString.toLowerCase();
    const title = schoolName ? schoolName.toLowerCase() : '';

    return title.includes(query);
};

const searchByMajor = (matchesMajorString, { majorCategory }) => {
    if (!matchesMajorString) return true;
    const query = matchesMajorString.toLowerCase();
    const title = majorCategory ? majorCategory.toLowerCase() : '';

    return title.includes(query);
};


const filterByRange = (values, rate) => (rate >= values[0] && rate <= values[1]);

const filterByTuition = (filter, tuition) => {
    if (filter === 0) {
        return true;
    }
    return filter === tuition;
};



// WEBPACK FOOTER //
// ./src/client/redux/programs.js